import { render, staticRenderFns } from "./PreferencesModal.vue?vue&type=template&id=055c4883&"
import script from "./PreferencesModal.vue?vue&type=script&lang=ts&"
export * from "./PreferencesModal.vue?vue&type=script&lang=ts&"
import style0 from "./PreferencesModal.vue?vue&type=style&index=0&id=055c4883&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports